import { IconButton, Input } from '@teamsnap/snap-ui';
import {
  InstallmentEditable,
  InstallmentPaymentMethod,
} from 'components/registration/v2/types';
import { convertFromPennies } from 'core/utils';
import * as React from 'react';
import { InstallmentFieldError, dateValidations } from './installmentHelpers';

export interface InstallmentEditableRowProps {
  installment: InstallmentEditable;
  onUpdateAmount: (amount: number) => void;
  onUpdateDate: (date: Date) => void;
  onDelete: () => void;
  max: number;
  canDelete: boolean;
  savedPaymentMethod?: InstallmentPaymentMethod;
  errors?: InstallmentFieldError;
}

const InstallmentRow = ({
  installment,
  max,
  canDelete,
  onUpdateAmount,
  onUpdateDate,
  onDelete,
  savedPaymentMethod,
  errors,
}: InstallmentEditableRowProps) => (
  <li className="sui-pb-1" data-testid="CollectBalance--installment">
    <div className="sui-flex sui-w-full sui-gap-1  sui-items-baseline">
      <Input
        allowDecimals
        inputProps={{
          min: 1,
          max,
          'aria-label': 'Installment amount',
          defaultValue: convertFromPennies(installment.amount),
        }}
        name={`amount-${installment._key}`}
        size="small"
        type="financial"
        onBlur={(e) => {
          onUpdateAmount(Number(e.target.value) * 100);
        }}
        className="sui-w-1/4"
        errors={errors?.amount ? [errors.amount] : undefined}
      />
      <span>on</span>
      <Input
        inputProps={{
          'aria-label': 'Installment date',
          min: dateValidations.tomorrow(),
          defaultValue: installment.scheduledDate,
        }}
        name={`date-${installment._key}`}
        size="small"
        type="date"
        onChange={(e) => {
          onUpdateDate(e.target.value);
        }}
        onBlur={(e) => {
          onUpdateDate(e.target.value);
        }}
        className="sui-w-1/4"
        errors={errors?.scheduledDate ? [errors.scheduledDate] : undefined}
      />
      {savedPaymentMethod && (
        <span className="sui-caption sui-py-1">
          {`${savedPaymentMethod.accountName?.toUpperCase()} ${
            savedPaymentMethod.last4 ? `(****${savedPaymentMethod.last4})` : ''
          }`}
        </span>
      )}
      {canDelete && (
        <IconButton
          data-testid="CollectBalance--cancel-installment"
          icon="delete"
          sentiment="negative"
          onClick={onDelete}
          className="sui-relative sui-ml-2"
          style={{ top: '0.5rem' }}
        />
      )}
    </div>
  </li>
);

export default InstallmentRow;
